import L from 'leaflet';
import { useForm } from "react-hook-form";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from 'axios';
import Swal from 'sweetalert2';
import ubicacionForm from '../assets/images/ubicacionForm.png';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { Departamento, Distrito, getSession, ModificarEmpresas, Municipio, PuntoCentral } from "../utils/utils";
import Cookies from 'js-cookie'
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from "react-leaflet";

const customIcon = new L.Icon({
	iconUrl: ubicacionForm, // Ruta de la imagen
	iconSize: [41, 41], // Tamaño del ícono
	iconAnchor: [12, 41], // Punto de anclaje del ícono
	popupAnchor: [1, -34], // Punto de anclaje del popup
	shadowSize: [41, 41], // Tamaño de la sombra
});

function FormularioEditarEmpresa() {

	const { id } = useParams();
	const navigate = useNavigate();

	const [departamento, setDepartamento] = useState([]);
	const [municipios, setMunicipios] = useState([]);
	const [distritos, setDistritos] = useState([]);
	const [centro, setCentro] = useState([])
	const [selectedPosition, setSelectedPosition] = useState(null);

	const [loading, setLoading] = useState(id ? true : false)
	const [userInfo, setUserInfo] = useState({
		email: null,
		name: null,
		company: null,
		role: null
	});

	async function getInfo() {
		let session = await getSession();
		
		if (session !== null) {
			setUserInfo(session);
			return;
		}

		navigate("/");

		return;
	}

	useEffect(

		function () {
			getInfo();
		}
		, []
	);

	const [editarEmpresa, setEditarEmpresa] = useState({
		nombre_empresa: '',
		nit_empresa: '',
		nombre_encargado: '',
		correo: '',
		tipo_acceso: '',
	})

	const { register, handleSubmit, formState: { errors }, setError, clearErrors, watch, setValue } = useForm({
		defaultValues: editarEmpresa
	})

	async function getDepartamento() {
		setDepartamento(await Departamento());
	}

	async function handleMunicipio(element) {
		// console.log(element);
		if (element.target.value !== "") {
			// console.log("handle");
			let municipioData = await Municipio(element.target.value);
			// console.log(municipioData);
			setMunicipios(municipioData);
			return;
		}

		setMunicipios([]);
		return;
	}

	useEffect(function () {
		getDepartamento();
	}, []);

	async function handleDistrito(element) {
		// console.log(element);
		if (element.target.value !== "") {
			// console.log("handle");
			let distritoData = await Distrito(element.target.value);
			// console.log(distritoData);
			setDistritos(distritoData);
			return;
		}

		setDistritos([]);
		return;
	}


	const validarNit = (value) => {
		const cleanedValue = value.replace(/[^0-9-]/g, "").replace(/\s/g, "");

		const soloNumeros = cleanedValue.replace(/-/g, "");
		if (soloNumeros.length > 15) return value;

		let formattedValue = soloNumeros.slice(0, 4);
		if (soloNumeros.length > 4) formattedValue += "-" + soloNumeros.slice(4, 10);
		if (soloNumeros.length > 10) formattedValue += "-" + soloNumeros.slice(10, 13);
		if (soloNumeros.length > 13) formattedValue += "-" + soloNumeros.slice(13, 14);
		if (soloNumeros.length > 14) formattedValue += "_" + soloNumeros.slice(14, 15);

		// Validación de longitud (15 dígitos + 3 guiones y un guion bajo)
		if (soloNumeros.length <= 15) {
			clearErrors("nit_empresa"); // Limpia el error si es válido
		} else {
			setError("nit_empresa", {
				type: "manual",
				message: "El NIT debe tener máximo 19 caracteres (15 números + 3 guiones + 1 guión bajo).",
			});
		}
		return formattedValue;
	}

	async function handleCentro(element) {

		if (element.target.value !== "") {
			let centroData = await PuntoCentral(element.target.value);
			if (centroData) {
				setCentro(centroData);
			} else {
				setCentro(
					{
						latitude: "13.79459900",
						longitude: "-88.93000000"
					});
			}
			return;
		}

		setCentro(
			{
				latitude: "13.79459900",
				longitude: "-88.93000000"
			});
	}

	const CenterMap = ({ position }) => {
		const map = useMap();
		useEffect(() => {
			if (position) {
				map.flyTo(position, 12); // Cambia el centro del mapa con una animación
			}
		}, [position, map]);
		return null;
	};

	const SelectLocation = ({ setSelectedPosition }) => {
		useMapEvents({
			click(e) {
				console.log("Coordenadas seleccionadas: " + e.latlng)
				setSelectedPosition(e.latlng); // Guarda la latitud y longitud
			},
		});
		return null;
	};

	async function getEmpresaList() {
		let empresa = await ModificarEmpresas(id);
		let departamentos = await Departamento();

		let departamentoResult = searchByName(departamentos, empresa.departamento, 'id');

		let municipios = await Municipio(departamentoResult);
		setMunicipios(municipios);
		let municipioResult = searchByName(municipios, empresa.municipio, 'id');

		let distritos = await Distrito(municipioResult);
		setDistritos(distritos);
		let distritoResult = searchByName(distritos, empresa.distrito, 'id');
		// console.log(empresa);
		// let edadesCapi = [];
		// console.log(empresa);
		let currentEmpresa = {
			nombre_empresa: empresa.nombre_empresa,
			nit_empresa: empresa.nit_empresa,
			departamento: departamentoResult ? departamentoResult : empresa.departamento,
			municipio: municipioResult ? municipioResult : empresa.municipio,
			distrito: distritoResult ? distritoResult : empresa.distrito,
			latitud: empresa.latitud,
			longitud: empresa.longitud,
			nombre_encargado: empresa.nombre_encargado,
			correo: empresa.correo,
			tipo_acceso: empresa.tipo_acceso,
		};
		console.log(currentEmpresa);
		let location = (currentEmpresa.latitud && currentEmpresa.longitud) ? {
			lat: parseFloat(currentEmpresa.latitud),
			lng: parseFloat(currentEmpresa.longitud)
		} : null ;

		setSelectedPosition(location);

		setValue("nombre_empresa", currentEmpresa.nombre_empresa);
		setValue("nit_empresa", currentEmpresa.nit_empresa);
		setValue("departamento", currentEmpresa.departamento);
		setValue("municipio", currentEmpresa.municipio);
		setValue("distrito", currentEmpresa.distrito);
		setValue("latitud", currentEmpresa.latitud);
		setValue("longitud", currentEmpresa.longitud);
		setValue("nombre_encargado", currentEmpresa.nombre_encargado);
		setValue("correo", currentEmpresa.correo);
		setValue("tipo_acceso", currentEmpresa.tipo_acceso);
		// setValue("imagen", currentEmpresa.imagen);

		setEditarEmpresa(currentEmpresa);

		return currentEmpresa;
	}

	const searchByName = (array, nameKey, element = null) => {
		let result = array.find((item) => item.name === nameKey);
		if (element) {
			return result[element];
		}

		return result;
	};

	const allFunctions = async () => {
		setLoading(true)
		setDepartamento(await Departamento());

		if (id) {
			await getEmpresaList();
		}
		setLoading(false)
	}

	useEffect(() => {
		allFunctions();
	}, [])

	async function validar(data) {		
		let dataToSend = {
			nombre_empresa: data.nombre_empresa,
			nit_empresa: data.nit_empresa,
			departamento: data.departamento,
			municipio: data.municipio,
			distrito: data.distrito,
			latitud: selectedPosition.lat,
			longitud: selectedPosition.lng,
			nombre_encargado: data.nombre_encargado,
			email: data.correo,
			tipo_acceso: data.tipo_acceso,
		};

		let session = Cookies.get("AuthToken");
		let uri = process.env.REACT_APP_API_URL + 'admin/usuarios/' + id;

		let config = {	
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Authorization': `Bearer ${session}`,
			}
		};

		try {
			let response = await axios({
				method: 'PUT',
				url: uri,
				data: dataToSend,
				headers: config.headers
			});
			console.log(response);
			Swal.fire(
				{
					title: 'Registro exitoso',
					text: 'Datos actualizados correctamente',
					icon: 'success',
					confirmButtonText: 'Aceptar'
				}
			)
				.then(function () {
					navigate("/VistaDatosEmpresas")
				}
				)
		} catch (error) {
			console.log(error);	
			Swal.fire({
				title: 'Hemos encontrado un inconveniente',
				text: 'Algunos de los datos ingresados no son válidos',
				icon: 'warning',
				confirmButtonText: 'Aceptar'				
			});  
		}
	}

	return (
		<div className="mt-5 md:ml-32 w-auto font-bold">
			<div className="flex flex-row justify-start items-center mb-4">
				<Link to="/VistaDatosEmpresas" className="flex justify-start">
					<button className="bg-white border-4 border-[#0E7FA0] font-medium drop-shadow-2xl shadow-2xl text-white w-full rounded-full w-[50px] h-[50px] p-[12px] mr-3"><FontAwesomeIcon icon={faArrowLeft} className='text-[#0E7FA0] text-lg' /></button>
				</Link>
				<p className="text-4xl font-bold text-[#063E5F] text-center">Editar Empresa</p>
			</div>
			<form onSubmit={handleSubmit(validar)} >
				<div className="flex flex-col mr-5 w-auto h-auto border-2 rounded-xl pb-6">
					<h1 className='bg-[#097493] text-white text-center text-2xl p-2 font-semibold rounded-t-xl'>Ingresar datos de la Empresa</h1>
					<div>
						<div className="flex flex-row p-2">
							<div className="mr-2 w-1/2 h-2/3">
								<label for="nombre">Nombre de la Empresa</label>
								<input id="" placeholder="Ingresar nombre de la empresa" className={`w-full border-2 p-4 text-lg bg-[#D1ECF2] rounded-lg font-normal outline-none ${errors.nombre_empresa ? 'border-red-600' : ''}`} type="text" {...register("nombre_empresa", { required: "El nombre de la empresa es requerido" })}
									value={editarEmpresa.nombre_empresa}
									defaultValue={editarEmpresa.nombre_empresa}
									onChange={(e) => setEditarEmpresa({
										...editarEmpresa,
										nombre_empresa: e.target.value
									})} />
								{errors.nombre_empresa && <span className="text-red-600 font-bold w-full px-2 flex justify-start">{errors.nombre_empresa.message}</span>}
							</div>
							<div className="mx-2 w-1/2 h-2/3">
								<label for="nombre">NIT de la empresa</label>
								<input type="tel" placeholder="NIT Empresa (####-######-####-#)" inputMode='numeric' maxLength='17' name='nit_empresa' id='nit_empresa' className={`w-full border-2 p-4 text-lg font-normal bg-[#D1ECF2] rounded-lg outline-none ${errors.nit_empresa ? 'border-red-600' : ''}`} {...register("nit_empresa", { required: "El NIT de la empresa es requerido" })} onChange={(event) => {
									const { value } = event.target
									setEditarEmpresa({
										...editarEmpresa,
										nombre_empresa: value
									})
									event.target.value = validarNit(value)
								}} />
								{errors.nit_empresa && <p className='text-red-600 font-bold w-full px-2 flex justify-start'>{errors.nit_empresa.message}</p>}
							</div>
						</div>
						<div className="flex flex-col md:flex-row px-2 justify-between w-auto">
							<div className="w-auto md:w-1/2">
								<div className="w-auto mb-2">
									<label className="p-1">Departamento</label>
									<select className={`w-full border-2 p-4 text-lg font-normal bg-[#D1ECF2] rounded-lg outline-none ${errors.departamento ? 'border-red-600' : ''}`} {...register("departamento", { required: "Selecciona tu departamento de residencia" })}
										onChange={(e) => {
											handleMunicipio(e)
											handleCentro(e)
											setEditarEmpresa({
												...editarEmpresa,
												nombre_empresa: e.target.value
											})
										}
										}
									>
										<option value="">Seleccione su departamento</option>
										{departamento.map(function (item, index) {
											return (
												<option key={index} value={item.id}>{item.name}</option>
											);
										})}
									</select>
									{errors.departamento && <span className='text-red-600 font-bold w-full px-2 flex justify-start'>{errors.departamento.message}</span>}
								</div>
								<div className="w-auto mb-2">
									<label className="p-1">Municipio</label>
									<select className={`w-full border-2 p-4 text-lg font-normal bg-[#D1ECF2] rounded-lg outline-none ${errors.municipio ? 'border-red-600' : ''}`} {...register("municipio", { required: "Selecciona tu municipio de residencia" })}
										onChange={(e) => {
											handleDistrito(e)
											setEditarEmpresa({
												...editarEmpresa,
												municipio: e.target.value
											})
										}}
									>
										<option value="">Seleccione su municipio</option>
										{municipios.map(function (item, index) {
											return (
												<option key={index} value={item.id}>{item.name}</option>
											);
										})}
									</select>
									{errors.municipio && <span className='text-red-600 font-bold w-full px-2 flex justify-start'>{errors.municipio.message}</span>}
								</div>
								<div className="w-auto mb-2">
									<label className="p-1">Distrito</label>
									<select className={`w-full border-2 p-4 text-lg font-normal bg-[#D1ECF2] rounded-lg outline-none ${errors.distrito ? 'border-red-600' : ''}`} {...register("distrito", { required: "Selecciona tu distrito de residencia" })}
										onChange={(e) => {
											setEditarEmpresa({
												...editarEmpresa,
												distrito: e.target.value
											});
										}} >
										<option value="">Seleccione su distrito</option>
										{distritos.map(function (item, index) {
											return (
												<option key={index} value={item.id}>{item.name}</option>
											);
										})}
									</select>
									{errors.distrito && <span className='text-red-600 font-bold w-full px-2 flex justify-start'>{errors.distrito.message}</span>}
								</div>
							</div>
							<div className='w-auto md:w-1/2 md:mx-2 mb-2'>
								<label htmlFor='mapa'>Selecciona la ubicación de tu empresa en el siguiente mapa:</label>
								<MapContainer center={[13.6989, -89.1914]} zoom={7} style={{ height: "300px", width: "100%" }}>
									<TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
									<CenterMap position={[
										centro.latitude ? parseFloat(centro.latitude) : 13.6989,
										centro.longitude ? parseFloat(centro.longitude) : -89.1914
									]} zoom={7} />
									<SelectLocation setSelectedPosition={setSelectedPosition} />
									{selectedPosition && (
										<Marker position={[selectedPosition.lat, selectedPosition.lng]} icon={customIcon} />
									)}
								</MapContainer>
								{selectedPosition && (
									<div className='flex flex-row justify-between'>
										<p>Latitud: {selectedPosition.lat}</p>
										<p>Longitud: {selectedPosition.lng}</p>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
				<div className="flex flex-col mr-5 w-auto border-2 rounded-xl mt-3 pb-6">
					<h1 className='bg-[#097493] text-white text-center text-2xl p-2 font-semibold rounded-t-xl'>Ingresar datos del Usuario</h1>
					<div>
						<div className="flex flex-row p-2">
							<div className="mr-2 w-1/3 h-2/3">
								<label for="nombre">Nombre del Encargado</label>
								<input id="" placeholder="Ingresar nombre del encargado" className={`w-full border-2 p-4 text-lg bg-[#D1ECF2] rounded-lg font-normal outline-none ${errors.nombre_encargado ? 'border-red-600' : ''}`} type="text" {...register("nombre_encargado", { required: "Ingresa el nombre del encargado" })}
									value={editarEmpresa.nombre_encargado}
									defaultValue={editarEmpresa.nombre_encargado}
									onChange={(e) => setEditarEmpresa({
										...editarEmpresa,
										nombre_encargado: e.target.value
									})} />
								{errors.nombre_encargado && <span className="text-red-600">{errors.nombre_encargado.message}</span>}
							</div>
							<div className="mx-2 w-1/3 h-2/3">
								<label for="nombre">Correo electrónico</label>
								<input id="" placeholder="ejemplo@correo.com" className={`w-full border-2 p-4 text-lg bg-[#D1ECF2] rounded-lg font-normal outline-none ${errors.correo ? 'border-red-600' : ''}`} type="email" {...register("correo", {
									required: {
										value: true,
										message: "Ingresa un correo electrónico"
									},
									pattern: {
										value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
										message: "Correo no válido"
									}
								})}
									value={editarEmpresa.correo}
									defaultValue={editarEmpresa.correo}
									onChange={(e) => setEditarEmpresa({
										...editarEmpresa,
										correo: e.target.value
									})} />
								{errors.correo && <span className='text-red-600'>{errors.correo.message}</span>}
							</div>
							<div className="ml-2 w-1/3 h-2/3">
								<label for="nombre">Tipo de Acceso</label>
								<select className={`w-full border-2 p-4 text-lg bg-[#D1ECF2] rounded-lg font-normal outline-none ${errors.tipo_acceso ? 'border-red-600' : ''}`} {...register("tipo_acceso", { required: "Elige el tipo de acceso" })}
									value={editarEmpresa.tipo_acceso}
									defaultValue={editarEmpresa.tipo_acceso}
									onChange={(e) => setEditarEmpresa({
										...editarEmpresa,
										tipo_acceso: e.target.value
									})} >
									<option value="">Selecciona el tipo de acceso</option>
									<option value="Empresa">Empresa</option>
									{/* <option value="Sucursal">Sucursal</option> */}
								</select>
								{errors.tipo_acceso && <span className="text-red-600">{errors.tipo_acceso.message}</span>}
							</div>
						</div>
					</div>
				</div>
				<div className="flex justify-end pt-3 pr-5">
					<div className='w-[260px] justify-between flex flex-row'>
						<Link to="/Mantenimiento" data-discover="true">
							<button className="bg-[#9E130D] font-medium drop-shadow-2xl shadow-2xl text-white rounded-full w-[125px] h-[50px] p-[12px]">Cancelar</button>
						</Link>
						<button type="submit" className="bg-[#99C33E] font-medium drop-shadow-2xl shadow-2xl text-white rounded-full w-[125px] h-[50px] p-[12px]">Agregar</button>
					</div>
				</div>
			</form>
		</div>
	)
}

export default FormularioEditarEmpresa;